import { createContext } from '@atlas-ui/utils';
import type { ProgressBarAria } from '@react-aria/progress';
import type { ProgressAppearance, ProgressSize } from './types';

export interface ProgressContextValue extends ProgressBarAria {
  isIndeterminate: boolean;
  size: ProgressSize;
  percentage: number;
  appearance: ProgressAppearance;
}

export const [ProgressProvider, useProgressContext] =
  createContext<ProgressContextValue>({
    hookName: 'useProgressContext',
    providerName: 'ProgressProvider',
  });
